import { pusherAppKey, getIsChina } from "config";

export const SENTRY_URL =
  "https://2cb0b982daf444ae91d6bfbf6da5a9de@sentry.io/1330341";

export const getCloudUrl = () => {
  if (getIsChina()) {
    return "https://cloud.toddleapp.cn";
  } else return "https://cloud.toddleapp.com";
};

/**
 * Deprecated, DO NOT USE
 * @type {string}
 */

export const getThumbBaseUrl = () => {
  return `${getCloudUrl()}/thumber/`;
};
export const DEFAULT_THUMB_IMAGE = `${getCloudUrl()}/assets/webapp/image_holder.png`;
export const DEFAULT_PROFILE_PIC = `${getCloudUrl()}/assets/webapp/profile_image.png`;

export const DEFAULT_LINK_THUMB_URL = `${getCloudUrl()}/assets/images/linkDefaultImage.png`;

export const PUSHER_APP_KEY = pusherAppKey;

export const PDFTRON_LICENSE_KEY =
  "Teacher Tools Private Limited:OEM:Toddle Classroom Management::B+:AMS(20260928):A2A543620437F80A4360B13AC9A2537860616F5C97006A45BB129CFA54F538A6428231F5C7";

export const PROJECTS_AND_IBEC_BULK_DOWNLOAD_PREVIEW_IMAGES = {
  STUDENT_NAME: `${getCloudUrl()}/assets/illustrations/IBEC_Download_StudentGrouping.png`,
  SUBMISSION_ITEM: `${getCloudUrl()}/assets/illustrations/IBEC_Download_SubmissionGrouping.png`,
  NO_GROUPING: `${getCloudUrl()}/assets/illustrations/IBEC_Download_NoGrouping.png`,
};

export const COVER_SHEET_BG_URL = `${getCloudUrl()}/assets/webapp/CoverSheet.png`;
export const RESOURCE_PLACEHOLDER_URL = `${getCloudUrl()}/assets/webapp/icn_LE.png`;

export const PERIOD_COLORS = [
  "#e3e0f6",
  "#F3E2F2",
  "#ffe4cc",
  "#E0F2E5",
  "#fff0cc",
  "#f7cccc",
  "#d1ecef",
  "#d3e4ee",
];

export const EXCLUDED_ASSESSMENT_TYPES = ["dp_pa", "dp_ep"];

export const PICKER_DEFAULT_IMAGES = {
  DOCS: `${getCloudUrl()}/assets/webapp/docs_new_icn.png`,
  SHEET: `${getCloudUrl()}/assets/webapp/sheets_new_icn.png`,
  SLIDES: `${getCloudUrl()}/assets/webapp/slides_new_icn.png`,
  UNKNOWN: `${getCloudUrl()}/assets/webapp/unknow_new_icn.png`,
  PDF: `${getCloudUrl()}/assets/webapp/pdf_new_icn.png`,
  VIDEO: `${getCloudUrl()}/assets/webapp/video_new_icn1.png`,
  AUDIO: `${getCloudUrl()}/assets/webapp/audio_icn.png`,
  ZIP: `${getCloudUrl()}/assets/webapp/ZIP.png`,
  NOTE: `${getCloudUrl()}/assets/webapp/note_icn.png`,
  EPUB: `${getCloudUrl()}/assets/webapp/epub_icn.png`,
  DRAWING: `${getCloudUrl()}/assets/webapp/drawings_new_icn.png`,
  WORKBOOK: `${getCloudUrl()}/assets/webapp/workbook_outlined.png`,
  IMAGE: `${getCloudUrl()}/assets/webapp/image_holder.png`,
  IMAGE_0: `${getCloudUrl()}/assets/illustrations/PlaceholderOne.svg`,
  IMAGE_1: `${getCloudUrl()}/assets/illustrations/PlaceholderTwo.svg`,
  IMAGE_2: `${getCloudUrl()}/assets/illustrations/PlaceholderThree.svg`,
  IMAGE_3: `${getCloudUrl()}/assets/illustrations/PlaceholderFour.svg`,
  IMAGE_4: `${getCloudUrl()}/assets/illustrations/PlaceholderFive.svg`,
  IMAGE_5: `${getCloudUrl()}/assets/illustrations/PlaceholderSix.svg`,
  IMAGE_6: `${getCloudUrl()}/assets/illustrations/PlaceholderSeven.svg`,
  IMAGE_7: `${getCloudUrl()}/assets/illustrations/PlaceholderEight.svg`,
  MATH_EQ: `${getCloudUrl()}/assets/webapp/math_eq.png`,
  CHEMISTRY_EQ: `${getCloudUrl()}/assets/webapp/math_eq.png`,
  XML: `${getCloudUrl()}/assets/webapp/code_outlined.png`,
};

export const ATTACHMENT_OMIT_ATTRIBUTES = [
  "__typename",
  "streamUrl",
  "signedUrl",
  "createdBy",
  "similarityReport",
  "isRead",
  "isAnnotationRead",
  "questionAttachment",
  "presetAttachment",
];

export const ATTACHMENT_INPUT_ATTRIBUTES = [
  "id",
  "type",
  "title",
  "url",
  "name",
  "mimeType",
  "thumbUrl",
  "createdBy",
  "description",
  "metadata",
  "parentId",
  "parentType",
  "studentTemplateId",
  "similarityReport",
];

//Use this object for creation of attachment in cache
export const ATTACHMENT_CREATE_ATTRIBUTES = {
  similarityReport: null,
  isRead: true,
  questionAttachment: null,
  lockingState: null,
  presetAttachment: null,
  isAnnotationRead: true,
};
